import React from 'react';
import LogoSvg from '../../images/white-full-size-logo.svg';
import LogoPrimary from '../../images/full-colored-logo.svg';

type LogoProps = {
  width: string;
  height: string;
  className?: string;
  style?: any;
  variant?: 'white' | 'primary'
};

const Logo = ({ width, height, className, style, variant='white' }: LogoProps) => {
  const logoProps = {
    style: {
      width, height, ...style,
    },
    className,
  }
  if(variant === 'primary'){
    return <LogoPrimary {...logoProps} />
  }
  return <LogoSvg {...logoProps} />
};

Logo.defaultProps = {
  width: '145px',
  height: '42px',
};

export default Logo;
